import React, { ReactNode } from 'react'

import withCondition from 'components/withCondition'

import { StyledSubHeader } from './styles'

interface DialogSubHeaderProps {
  SubHeader: string | ReactNode
}

function DialogSubHeaderComponent({ SubHeader }: DialogSubHeaderProps) {
  if (typeof SubHeader === 'string') {
    return <StyledSubHeader>{SubHeader}</StyledSubHeader>
  }

  return SubHeader
}

export const DialogSubHeader = withCondition(DialogSubHeaderComponent)
